/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * Analyzer API
 * Analyzer API gateway
 * OpenAPI spec version: 1.0.0
 */

export type DuplicateAnalysisBadRequestErrorCode =
  (typeof DuplicateAnalysisBadRequestErrorCode)[keyof typeof DuplicateAnalysisBadRequestErrorCode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DuplicateAnalysisBadRequestErrorCode = {
  analysis_already_exists_for_client: "analysis_already_exists_for_client",
  nsure_self_dealing_forbidden: "nsure_self_dealing_forbidden",
  analysis_in_progress: "analysis_in_progress",
  analysis_version_archived: "analysis_version_archived",
} as const;
